import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    orderForm: null,
    loading: false,
    error: null
};

const getOrderFormRequest = (state, action) => {
    return updateState(state, {
        loading: true,
        error: null,
        orderForm: null
    });
};

const getOrderFormSuccess = (state, action) => {
    return updateState(state, {
        loading: false,
        error: null,
        orderForm: action.data
    });
};

const getOrderFormError = (state, action) => {
    return updateState(state, {
        loading: false,
        error: action.error
    });
};

const clearOrderFormError = (state, action) => {
    return updateState(state, {
        error: null
    });
};

export function orderFormReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_ORDER_FORM_REQUEST :
            return getOrderFormRequest(state, action);

        case actionTypes.GET_ORDER_FORM_SUCCESS :
            return getOrderFormSuccess(state, action);

        case actionTypes.GET_ORDER_FORM_ERROR :
            return getOrderFormError(state, action);


        case actionTypes.CLEAR_ALL_ERRORS :
            return clearOrderFormError(state, action);

        default:
            return state;
    }
}
